import { validatePhoneNumber } from '../../lib/funnels/functions/v1/formats/validatePhoneNumber.js'
import { showInputError } from '../../lib/funnels/functions/v1/html/showInputError.js'
import { hideInputError } from '../../lib/funnels/functions/v1/html/hideInputError.js'
import { setUpFormInputs } from '../../lib/funnels/functions/v1/html/setupFormInputs.js'

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Set up form inputs (phone mask, validation, etc.)
  setUpFormInputs()

  const form = document.getElementById('unsubscribe-form')

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault()

      const phoneInputElement = /** @type {HTMLInputElement} */ (
        document.getElementById('phone')
      )
      if (!phoneInputElement) return

      const phoneValue = phoneInputElement.value.trim()

      if (!phoneValue) {
        phoneInputElement.setAttribute(
          'data-error-message',
          'Phone number is required',
        )
        showInputError(phoneInputElement)
        return
      }

      if (!validatePhoneNumber(phoneValue)) {
        phoneInputElement.setAttribute(
          'data-error-message',
          'Please enter a valid phone number',
        )
        showInputError(phoneInputElement)
        return
      }

      hideInputError(phoneInputElement)

      // Hide the form
      const formContainer = document.getElementById(
        'unsubscribe-form-container',
      )
      const successMessage = document.getElementById('success-message')

      if (formContainer) {
        formContainer.style.display = 'none'
      }

      if (successMessage) {
        successMessage.style.display = 'block'
      }
    })
  }
})
